import React from 'react'
import styles from 'components/cases/common/Overview/Overview.module.scss'
import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: 'AI時代の開発生産性を支えるデザインシステムを構築',
  title1: <>AI時代の開発生産性を支えるデザインシステムを構築</>,
  company: '株式会社アルダグラム',
  introduction_text: (
    <>
      現場DXサービス「KANNA」は、2020年のサービス開始以来、スピード感のある機能追加により、国内外での導入企業数100,000社達成という目覚ましい成長を続けてきました。その一方で、FigmaのデザインとUI実装のズレ、画面ごとに増え続けるコンポーネント、そして「KANNAらしさ」が社内で言語化されていないといった課題がありました。そこで踏み切ったのが、デザインシステムの構築です。
      <br />
      日常業務と並行して取り組むなかで選んだのは、外部にすべてを委ねるのではなく「自分たちが主体的に進める」道でした。アイスリーデザインは、要件定義でスコープを見極め、テンプレート提供とレビューによる伴走で、アルダグラムが主体的にデザインシステムを内製・運用できる仕組みづくりを支援しました。
    </>
  ),
  tag1text: 'デザインシステム構築支援',
  tag1src: '/cases/design-system/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  image: '/images/img/cases/aldagram/mv.webp',
  movie: '',
  alt: '株式会社アルダグラム AI時代の開発生産性を支えるデザインシステムを構築',
}

// プロジェクト概要
export const overviewTitle = '将来的な内製での運用を目指したデザインシステム構築'

export const overviewItem: OverviewItems[] = [
  {
    text: '現場DXサービス「KANNA」を運営する株式会社アルダグラムは、プロダクトの成長に向けてのデザインと開発の効率化のために、デザインシステムの必要性を感じていました。',
  },
  {
    text: '2020年のサービス開始から数年、機能追加を優先してきた結果、デザインと実装のズレやコンポーネントの乱立が生じ、慢性的なコミュニケーションコストが課題に。しかし、デザインチームは4名体制で、プロダクト開発とコミュニケーションデザインを兼務。整備したい気持ちはあっても、日常の業務に追われて着手できない状況が続いていました。',
  },
  {
    text: (
      <>
        アイスリーデザインは、約5か月というプロジェクト期間のなかで「何を・どこまで作るか」を要件定義で見極め、テンプレート提供とレビューによる伴走スタイルを提案。アルダグラムのデザイナーが自分たちの手でデザインシステムを作り、運用し続けられるようになることをゴールに支援しました。
      </>
    ),
  },
  {
    text: '今回は、アルダグラムのデザイナーである清水さん、小野田さん、五十嵐さん、松木さん、エンジニアの今町さん、影山さん、吉澤さん、そしてアイスリーデザインのプロジェクトマネージャー・今野、デザイナー・大林に、プロジェクトの舞台裏を伺いました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'デザインと実装のズレ',
        text: 'FigmaのデザインとUI実装が微妙に食い違い、同じ機能でも画面によってボタンの大きさ・色・余白が異なる状態。「どちらが正解か」を都度議論するコミュニケーションコストが慢性化し、コードも個別最適化によって混乱していた。',
      },
      {
        title: 'デザインの判断基準が属人化',
        text: '使いやすいデザインの基準がデザイナーごとに異なっており、プロダクト内でそれぞれが作成したコンポーネントが乱立していた。',
      },
      {
        title: '生成AI時代に「土台のなさ」が足かせに',
        text: 'デザイントークンやコンポーネントが整理されていないままAIでコード生成を進めると、際限なく新しいデザインが作られてしまい、エンジニアが把握・管理できない状態になる恐れがあった。',
      },
    ],
    solutions: [
      {
        title: '要件定義でスコープを見極める',
        text: '約5か月で成果を出すために現状の画面を精査し、よく使われるデザインとそれらの実装差異を洗い出し。「どのコンポーネントについて、どこまでガイドラインを作るか」の優先順位を先に固めた。',
      },
      {
        title: 'テンプレート提供とレビューによる伴走',
        text: 'アイスリーデザインがテンプレートを用意し、中身はアルダグラムが議論しながら内製。その成果物に対してレビューとフィードバックを行い、判断が難しい場面で方針を示した。',
      },
      {
        title: 'スキルトランスファーで内製・自走を実現',
        text: 'Figmaのコンポーネントの作り方からレクチャーし、アルダグラムが自分たちで考えて進められる状態へ。デザインシステムは更新し続けるものであるため、自社が主体的に動くことで将来的な内製運用も見据えられるようになる、という考えに基づいた。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: 'デザインシステムで組織の生産性を向上させませんか？',
  description: (
    <>
      ブランディングと開発効率改善をデザインシステムで叶えます。
      <br />
      ぜひお気軽に課題やゴールをお聞かせください。
    </>
  ),
}
